/** Marque Python Learning — invite REPL « >_ » sur une puce arrondie.
 *  Chevron (saisie) + underscore (curseur actif / succès). Les couleurs sont
 *  tirées des tokens de thème (var(--blue) / --bg-base / --green) : la marque
 *  s'adapte donc automatiquement à Mocha (sombre) comme à Latte (clair). */
export default function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="Python Learning"
      style={{ flexShrink: 0, display: "block" }}
    >
      <rect width="64" height="64" rx="14" fill="var(--blue)" />
      <polyline
        points="20,42 34,32 20,22"
        stroke="var(--bg-base)"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="32"
        y1="46"
        x2="46"
        y2="46"
        stroke="var(--green)"
        strokeWidth="5.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Verrou de marque : la puce + le mot-symbole « Python Learning ». */
export function LogoLockup({ size = 28 }: { size?: number }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <Logo size={size} />
      <span
        style={{
          fontWeight: 600,
          fontSize: size * 0.62,
          letterSpacing: "-0.4px",
          color: "var(--text)",
        }}
      >
        Python Learning
      </span>
    </span>
  );
}
